import _ from 'lodash'
import { Message, MessageBox } from 'element-ui'
const plugin = {}

class ErrorMessageHandler {
  _close = undefined
  apply (target, thisArg, argArray) {
    const message = '操作失败'
    const [options, ...args] = argArray
    const myOptions = {
      message
    }
    if (options) {
      _.merge(myOptions, typeof options === 'string' ? { message: options } : options)
    }
    if (this._close) {
      this._close()
      this._close = undefined
    }
    const { close } = target.apply(thisArg, [myOptions || message, ...args])

    this._close = close
    return close
  }
}
class SuccessMessageHandler {
  _close = undefined
  apply (target, thisArg, argArray) {
    const message = '操作成功'
    const [options, ...args] = argArray
    const myOptions = {
      message
    }
    if (options) {
      _.merge(myOptions, typeof options === 'string' ? { message: options } : options)
    }
    if (this._close) {
      this._close()
      this._close = undefined
    }
    const { close } = target.apply(thisArg, [myOptions || message, ...args])

    this._close = close
    return close
  }
}

plugin.install = function (vue) {
  // 格式化时间
  // eslint-disable-next-line no-extend-native
  Date.prototype.format = function (fmt) {
    var o = {
      'M+': this.getMonth() + 1, // 月份
      'd+': this.getDate(), // 日
      'h+': this.getHours(), // 小时
      'm+': this.getMinutes(), // 分
      's+': this.getSeconds(), // 秒
      'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
      'S': this.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (this.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  }

  const handler = {
    error: new ErrorMessageHandler(),
    success: new SuccessMessageHandler()
  }
  Object.keys(handler).forEach(key => {
    const target = Message[key]
    if (target && handler[key]) {
      Message[key] = new Proxy(target, handler[key])
    }
  })

  // 全局message弹出框方法
  vue.prototype.$Message = function (type, content, duration, offset) {
    return Message({
      duration: duration || 3000,
      offset: offset || 60,
      type: type,
      message: content
    })
  }

  // 全局提交确认弹出框方法
  vue.prototype.$Submit = function (options = {
    confirm: () => { },
    cancel: () => { },
    message: '确认是否继续操作？',
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  }) {
    return MessageBox.confirm(options.message ? options.message : '确认是否继续操作？', '提示', {
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      confirmButtonText: options.confirmButtonText ? options.confirmButtonText : '确定',
      cancelButtonText: options.cancelButtonText ? options.cancelButtonText : '取消',
      type: 'info'
    }).then(() => {
      options.confirm && options.confirm()
    }).catch((e) => {
      options.cancel && options.cancel()
      return Promise.reject(e)
    })
  }

  // 全局删除确认弹出框方法
  vue.prototype.$Delete = function (options = {
    confirm: () => { },
    cancel: () => { },
    message: '是否确认删除?'
  }) {
    return MessageBox.confirm(options.message ? options.message : '是否确认删除?', '提示', {
      showClose: false,
      closeOnClickModal: false,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnPressEscape: false,
      type: 'warning',
      customClass: 'warning'
    }).then(() => {
      options.confirm && options.confirm()
    }).catch((e) => {
      options.cancel && options.cancel()
      return Promise.reject(e)
    })
  }

  // 拦截全局$loading，添加默认参数
  vue.prototype.$loading = _.wrap(vue.prototype.$loading, function (func, options) {
    const opts = {
      fullscreen: true,
      background: 'rgba(0,0,0,0.5)',
      ...options
    }
    return func(opts)
  })
  console.log(vue.prototype.$loading)

  vue.mixin({
    computed: {
      zoomFactor () {
        const rootValue = 100
        const pc = rootValue / 1920 // 表示1366的设计图,使用90px的默认值
        let width = window.screen.width // 当前窗口的宽度
        const height = window.screen.height // 当前窗口的高度
        let rem = ''
        const currentHeight = (width * 1080) / 1920
        if (height < currentHeight) {
          // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
          width = (height * 1920) / 1080
        }
        rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
        return rem / 100
      }
    }
  })
}

export default plugin
